import type { LinkResult, ResolvedTransactionModel, TransactionsIntent } from './intents';
import { legacyAdapter } from './legacyAdapter';
import { transferGroupsAdapter } from './transferGroupsAdapter';

const adapters = {
  legacy: legacyAdapter,
  transferGroups: transferGroupsAdapter,
} as const;

export function buildTransactionsLink(
  model: ResolvedTransactionModel,
  intent: TransactionsIntent,
): LinkResult {
  const adapter = adapters[model];
  switch (intent.kind) {
    case 'all':
      return adapter.all(intent);
    case 'byHash':
      return adapter.byHash(intent);
    case 'byImports':
      return adapter.byImports(intent);
    case 'byAccounts':
      return adapter.byAccounts(intent);
    case 'byCurrency':
      return adapter.byCurrency(intent);
    case 'byCurrencyOnDate':
      return adapter.byCurrencyOnDate(intent);
    case 'byDateCurrencyHash':
      return adapter.byDateCurrencyHash(intent);
    case 'byMethodId':
      return adapter.byMethodId(intent);
    case 'byContractAddress':
      return adapter.byContractAddress(intent);
    case 'byTransferAddress':
      return adapter.byTransferAddress(intent);
    case 'byTransferGroup':
      return adapter.byTransferGroup(intent);
    case 'workpaperTransactions':
      return adapter.workpaperTransactions(intent);
    case 'pricingAnomalies':
      return adapter.pricingAnomalies(intent);
    case 'missingPrices':
      return adapter.missingPrices(intent);
    case 'byReconIdentifier':
      return adapter.byReconIdentifier(intent);
    case 'byTxnTopicFingerprint':
      return adapter.byTxnTopicFingerprint(intent);
    case 'byTransferTopicFingerprint':
      return adapter.byTransferTopicFingerprint(intent);
  }
}
